<template>

<div align="justify">
    <p class="h4" align="center">Контактная информация</p>
    <div align="justify">
        <table>
            <tr>
                <td style="width: 30px;"><img alt="Адрес" src="/img/ais/address.png" width="24"></td>
                <td><strong style="color: blue;">169300, Республика Коми, г. Ухта, ул. Первомайская, д.35А.</strong></td>
            </tr>
            <tr>
                <td><img alt="Телефон" src="/img/ais/phone.png" width="24"></td>
                <td><strong style="color: blue;">+7 (8216) 76-33-06</strong></td>
            </tr>
            <tr>
                <td><img alt="E-mail" src="/img/ais/e-mail.png" width="24"></td>
                <td><strong style="color: blue;">office@ais-center.ru</strong></td>
            </tr>
        </table>
        <br>
    </div>
    
    <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac4cac27dab6ccdc9daea38b53cbe8a5aacdcc27c5901f7ee984f21a1db5820b9&amp;source=constructor;scroll=false" width="100%" height="450" frameborder="0"></iframe>
    
    <div align="justify">
        <h5>Данные организации:</h5>
        <table>
            <tr>
                <td>Сокращенное наименование:</td>
                <td><strong style="color: blue;">ООО "АИС"</strong></td>
            </tr>
            <tr>
                <td>Полное наименование:</td>
                <td><strong style="color: blue;">Общество с ограниченной ответственностью "АИС"</strong></td>
            </tr>
            <tr>
                <td>ИНН:</td>
                <td><strong style="color: blue;">1102057840</strong></td>
            </tr>
            <tr>
                <td>КПП:</td>
                <td><strong style="color: blue;">110201001</strong></td>
            </tr>
            <tr>
                <td>ОГРН:</td>
                <td><strong style="color: blue;">1081102000924</strong></td>
            </tr>
        </table>
        <br>
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

